import React from 'react';
import TokenIcon from './TokenIcon';
import { useTheme } from '../theme';

export default function TokenStack({ tokens, size = 26 }) {
  const { colors } = useTheme();
  const visible = tokens.slice(0, 3);
  const overlap = Math.round(size * 0.32);

  return (
    <div style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
      {visible.map((t, i) => (
        <div key={t + i} style={{
          marginLeft: i === 0 ? 0 : -overlap,
          zIndex: visible.length - i,
          position: "relative",
          border: `2px solid ${colors.surface}`,
          borderRadius: "50%",
          lineHeight: 0,
        }}>
          <TokenIcon symbol={t} size={size} />
        </div>
      ))}
    </div>
  );
}
